import React from "react";

function EmptyState({ text = "موردی یافت نشد." }) {
    return (
        <div className="admin-empty-state">
            <i className="bi bi-inbox"></i>
            <p className="mb-0">{text}</p>
        </div>
    );
}

export default EmptyState;
